import { render } from "./BulletTextarea.vue?vue&type=template&id=2dce9549&scoped=true"
import script from "./BulletTextarea.vue?vue&type=script&lang=js"
export * from "./BulletTextarea.vue?vue&type=script&lang=js"

import "./BulletTextarea.vue?vue&type=style&index=0&id=2dce9549&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dce9549"]])

export default __exports__